var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBg9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 370,
    height: 133,
    viewBox: "0 0 370 133",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M422.44 97.9706C520.284 208.581 412.151 179.132 422.44 193.11C442.822 235.116 444.216 265.571 444.997 267.831C445.974 270.655 268.004 280.65 264.292 279.998C261.323 279.477 55.8467 264.427 -46.5201 256.967C-71.3955 192.293 -44.1758 111.153 -44.1758 111.153C-44.1758 111.153 -167 -61.5733 14.4978 23.607C239 128.971 330.444 -6.02942 422.44 97.9706Z",
    fill: "#4B5E7F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg9);
export default __webpack_public_path__ + "static/media/bg-9.f75ad73c5f9f96f910c200c93ea6bda0.svg";
export { ForwardRef as ReactComponent };